import type { QueryClient } from "@tanstack/react-query";
import { TeachersApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi, createOpenApiConfiguration } from "@/lib/utils";
import { resolveEffectiveTenantNumber } from "@/lib/utils/env/effective-tenant";

export async function prefetchTeacherPublic(
  queryClient: QueryClient,
  teacherId: number,
  accessToken?: string,
) {
  const service = accessToken
    ? createAuthenticatedApi(TeachersApi, accessToken)
    : new TeachersApi(createOpenApiConfiguration());

  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.Teacher, teacherId, "public"],
    queryFn: () =>
      service.getTeacherById({
        id: teacherId,
        xTenantID: resolveEffectiveTenantNumber(),
      }),
  });

  return queryClient;
}
